import React, { useEffect, useState } from "react";
import HeadingBanner from "../components/HeadingBanner";
import QRClassCard from "../components/QRClassCard";
import LeftPanel from "../components/LeftPanel";
import AlpacaInfoGesture from "../components/AlpacaInfoGesture";
import {
  whoami,
  getClasses,
  getTeachers,
  getSchools,
  getCountryGrades,
  getTrialistsBySchool,
  getCountryId,
  getScreeningWindowStatuses,
  getPilotBySchoolId,
  getActiveGradeLevel3Schools,
  getPurchasesBySchool,
} from "../services/APIClient";
import { Container, Row, Col } from "react-bootstrap";
import "../components/ClassCard.css";
import ClassFilter from "../components/ClassFilter";
import OrientationPrompt from "../components/OrientationPrompt";
import FreeTrialBanner from "../components/FreeTrialBanner";
const VideoModal = React.lazy(() =>
  import("../components/VideoModal")
);

function QRDashboard() {
  const [schoolid, setSchoolid] = useState(null);
  const [countryId, setCountryId] = useState(null);
  const [teacherid, setTeacherid] = useState(null);
  const [name, setName] = useState("");
  const [teachers, setTeachers] = useState(null);
  const [firstname, setFirstname] = useState(null);
  const [speechText, setSpeechText] = useState(null);
  const [classes, setClasses] = useState([]);
  const [rollNumber, setRollNumber] = useState(null);
  const [filteredClasses, setFilteredClasses] = useState([]);
  const [gradeLevelOptions, setGradeLevelOptions] = useState([]);
  const [teacherRoles, setTeacherRoles] = useState(null);
  const [isPortrait, setIsPortrait] = useState(
    window.matchMedia("(orientation: portrait)").matches
  );
  const [gradeLevel3Schools, setGradeLevel3Schools] = useState([]);

  const [trialistDetails, setTrialistDetails] = useState(null);
  const [freeDaysLeft, setFreeDaysLeft] = useState(null);
  const [showTrialEndedModal, setShowTrialEndedModal] = useState(false);
  const { expired = false, purchased = false, purchased_2425 = false, purchased_2526 = false } = trialistDetails || {};

  const [existingConversionMethods, setExistingConversionMethods] = useState([]);
  const [pilotData, setPilotData] = useState(null);
  const [screeningWindowData, setScreeningWindowData] = useState(null);
  const [latestPurchase, setLatestPurchase] = useState(null);
  const DEFAULT_COUNTRY_ID = '07d45b79-24b1-435f-b82a-93861b23a86e';
  const isPilot = pilotData && pilotData.length > 0 && pilotData[0].active;

  const now = new Date();


  // Country IDs
  const englandId = "74bb2897-dbbe-41e3-b547-caee866545cf";
  const usaId = "ab40949f-001e-48b9-848e-126decad8471";
  const uaeId = "1cb16a5c-7c0a-4e7a-bcbc-b409024dd6cf";
  const malaysiaId = "f2d8569e-47ca-4e88-8736-797a7acd37f3";
  const northernIrelandId = "622e7844-a15e-4b91-9f64-12bf71ed7cff";
  const indiaId = "cd512001-3e26-4725-9a17-1155fc722db7";


  // Region-specific video content
const getVideoContent = () => {
    if (countryId === englandId || countryId === malaysiaId) {
      // UK content (no changes)
      return {
        buttonText: "📺 Show these videos in class before screening and review word & image list for AEN and EAL",
        modalTitle: "Before you start screening your pupils...",
        modalParagraph: "Please make sure to show this video to your class before screening. If you do that, children will understand they are about to go play a game and they will realize there are different types of questions that are going to be asked. You can make it an interactive activity in the classroom where you play the video in front of whole class, pause it after each question and ask for volunteers to give the answer.",
        videos: [
          {
            title: "Reception Baseline Screener Walkthrough",
            iframe: "https://www.youtube.com/embed/nxMDULDDMo8",
            pdf_title: "Reception Baseline Word & Image List - PDF Guide",
            pdf: "https://26983596.fs1.hubspotusercontent-eu1.net/hubfs/26983596/SandBox%20Content/Reception%20Baseline%20Word%20&%20Image%20list.pdf"
          },
          {
            title: "Year 1 Baseline Screener Walkthrough",
            iframe: "https://www.youtube.com/embed/5JWSSI9jRys",
            pdf_title: "Year 1 Baseline Word & Image List - PDF Guide",
            pdf: "https://26983596.fs1.hubspotusercontent-eu1.net/hubfs/26983596/Year%201%20Baseline%20Word%20&%20Image%20list.pdf"
          }
        ]
      };
    } else if (countryId === usaId) {
      // USA content (no changes)
      return {
        buttonText: "📺 Show these videos in class before screening and review word & image list for AEN and ESL",
        modalTitle: "Before you start screening your students...",
        modalParagraph: "Please make sure to show this video to your class before screening. If you do that, children will understand they are about to go play a game and they will realize there are different types of questions that are going to be asked. You can make it an interactive activity in the classroom where you play the video in front of whole class, pause it after each question and ask for volunteers to give the answer.",
        videos: [
          {
            title: "Pre-K Midpoint Screener Walkthrough",
            iframe: "https://www.youtube.com/embed/Wze4acpFG5M?si=R9Qgu65LZgW_T4Z_",
            pdf_title: "Pre-K Midpoint Word & Image List - PDF Guide",
            pdf: "https://26983596.fs1.hubspotusercontent-eu1.net/hubfs/26983596/SandBox%20Content/Additional%20Resources/GradeLevel1%20Word%20&%20Image%20list%20-%20Midpoint.pdf"
          },
          {
            title: "Kindergarten Midpoint Screener Walkthrough",
            iframe: "https://www.youtube.com/embed/04gpHzRb-q4?si=mrHMYb6uiczXrydM",
            pdf_title: "Kindergarten Midpoint Word & Image List - PDF Guide",
            pdf: "https://26983596.fs1.hubspotusercontent-eu1.net/hubfs/26983596/SandBox%20Content/Additional%20Resources/GradeLevel2%20Word%20&%20Image%20list%20-%20Midpoint.pdf"
          }
        ]
      };
    } else if (countryId === uaeId) {
      // UAE content (no changes)
      return {
        buttonText: "📺 Show these videos in class before screening and review word & image list for AEN and EAL",
        modalTitle: "Before you start screening your students...",
        modalParagraph: "Please make sure to show this video to your class before screening. If you do that, children will understand they are about to go play a game and they will realize there are different types of questions that are going to be asked. You can make it an interactive activity in the classroom where you play the video in front of whole class, pause it after each question and ask for volunteers to give the answer.",
        videos: [
          {
            title: "KG1 Baseline Screener Walkthrough",
            iframe: "https://www.youtube.com/embed/gMrbihlzlVI",
            pdf_title: "KG1 Baseline Word & Image List - PDF Guide",
            pdf: "https://26983596.fs1.hubspotusercontent-eu1.net/hubfs/26983596/chatbot%20video/KG1%20Baseline%20Word%20&%20Image%20list%20V2.pdf"
          },
          {
            title: "KG2 Baseline Screener Walkthrough",
            iframe: "https://www.youtube.com/embed/nesNSdq3oX4",
            pdf_title: "KG2 Baseline Word & Image List - PDF Guide",
            pdf: "https://26983596.fs1.hubspotusercontent-eu1.net/hubfs/26983596/chatbot%20video/KG2%20Baseline%20Word%20&%20Image%20list%20V2.pdf"
          }
        ]
      };
    } else if (countryId === indiaId) {
      // India content
      return {
        buttonText: "📺 Show these videos in class before screening and review word & image list for AEN and EAL",
        modalTitle: "Before you start screening your students...",
        modalParagraph: "Please make sure to show this video to your class before screening. If you do that, children will understand they are about to go play a game and they will realize there are different types of questions that are going to be asked. You can make it an interactive activity in the classroom where you play the video in front of whole class, pause it after each question and ask for volunteers to give the answer.",
        videos: [
          {
            title: "LKG Baseline Screener Walkthrough",
            iframe: "https://www.youtube.com/embed/D5FeMLrFOjA",
            pdf_title: "LKG Baseline Word & Image List - PDF Guide",
            pdf: "https://26983596.fs1.hubspotusercontent-eu1.net/hubfs/26983596/India%20LKG%20Baseline%20Word%20&%20Image%20list.pdf"
          },
          {
            title: "UKG Baseline Screener Walkthrough",
            iframe: "https://www.youtube.com/embed/FiJOsoI9lls",
            pdf_title: "UKG Baseline Word & Image List - PDF Guide",
            pdf: "https://26983596.fs1.hubspotusercontent-eu1.net/hubfs/26983596/India%20UKG%20Baseline%20Word%20&%20Image%20list.pdf"
          }
        ]
      };
    } else if (countryId === northernIrelandId) {
      // Northern Ireland content
      return {
        buttonText: "📺 Show these videos in class before screening and review word & image list for AEN and EAL",
        modalTitle: "Before you start screening your students...",
        modalParagraph: "Please make sure to show this video to your class before screening. If you do that, children will understand they are about to go play a game and they will realize there are different types of questions that are going to be asked. You can make it an interactive activity in the classroom where you play the video in front of whole class, pause it after each question and ask for volunteers to give the answer.",
        videos: [
          {
            title: "P1 Baseline Screener Walkthrough",
            // Irish Version: "https://www.youtube.com/embed/i0gclNlkfCM"
            iframe: "https://www.youtube.com/embed/J7m0DRW8DiM",
            pdf_title: "P1 Baseline Word & Image List - PDF Guide",
            // Irish Version: "https://26983596.fs1.hubspotusercontent-eu1.net/hubfs/26983596/chatbot%20video/P1%20Baseline%20Word%20&%20Image%20list%20-%20Ire%20Version.pdf"
            pdf: "https://26983596.fs1.hubspotusercontent-eu1.net/hubfs/26983596/P1%20Baseline%20Word%20&%20Image%20list.pdf"
          },
          {
            title: "P2 Baseline Screener Walkthrough",
            // Irish Version: "https://www.youtube.com/embed/l3jRDUCs77E"
            iframe: "https://www.youtube.com/embed/09tQNqn3ICo",
            pdf_title: "P2 Baseline Word & Image List - PDF Guide",
            // Irish Version: "https://26983596.fs1.hubspotusercontent-eu1.net/hubfs/26983596/chatbot%20video/P2%20Baseline%20Word%20&%20Image%20list%20-%20Ire%20Version.pdf"
            pdf: "https://26983596.fs1.hubspotusercontent-eu1.net/hubfs/26983596/P2%20Baseline%20Word%20&%20Image%20list.pdf"
          }
        ]
      };
    } else {
      // Default/Irish content - WITH conditional 1st Class addition
      const defaultVideos = [
        {
          title: "Junior Infant Baseline Screener Walkthrough",
          iframe: "https://www.youtube.com/embed/RYCtBPsQgZg?si=QiXtbgA68yrxEfzu",
          pdf_title: "Junior Infant Baseline Word & Image List - PDF Guide",
          pdf: "https://26983596.fs1.hubspotusercontent-eu1.net/hubfs/26983596/Grade%20Level%201%20Baseline%20Word%20&%20Image%20list.pdf"

        },
        {
          title: "Senior Infant Baseline Screener Walkthrough",
          iframe: "https://www.youtube.com/embed/byobxVtCV74?si=PwTSjSvS0729zELy",
          pdf_title: "Senior Infant Baseline Word & Image List - PDF Guide",
          pdf: "https://26983596.fs1.hubspotusercontent-eu1.net/hubfs/26983596/Grade%20Level%202%20Baseline%20Word%20&%20Image%20list.pdf"
        }
      ];

      // Add 1st Class content for allowed schools
      if (schoolid && gradeLevel3Schools.includes(schoolid)) {
        defaultVideos.push({
          title: "1st Class Baseline Screener Walkthrough",
          iframe: "https://www.youtube.com/embed/7qzWqnzO-Ho",
          pdf_title: "1st Class Baseline Word & Image List - PDF Guide",
          pdf: "https://26983596.fs1.hubspotusercontent-eu1.net/hubfs/26983596/1st%20Class%20Word%20%26%20Image%20list%20-%20Baseline.pdf"
        });
      }

      return {
        buttonText: "📺 Show these videos in class before screening and review word & image list for AEN and EAL",
        modalTitle: "Before you start screening your pupils...",
        modalParagraph: "Please make sure to show this video to your class before screening. If you do that, children will understand they are about to go play a game and they will realize there are different types of questions that are going to be asked. You can make it an interactive activity in the classroom where you play the video in front of whole class, pause it after each question and ask for volunteers to give the answer.",
        videos: defaultVideos
      };
    }
  };


  useEffect(() => {
    const handleOrientationChange = () => {
      setIsPortrait(window.innerWidth < window.innerHeight);
    };

    window.addEventListener("resize", handleOrientationChange);

    return () => {
      window.removeEventListener("resize", handleOrientationChange);
    };
  }, []);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    whoami().then((response) => {
      setSchoolid(response.data.stakeholder.schoolid);
      setTeacherid(response.data.stakeholder.id);
      setName(response.data.stakeholder.name);
      setTeacherRoles(response.data.stakeholder.additionalRoles)
    });
  }, []);

  useEffect(() => {
    async function fetchSchoolData() {
      try {
        const teachersResponse = await getTeachers(schoolid);
        setTeachers(teachersResponse);

        let classesResponse = await getClasses();

        // Remove duplicate classes based on their id
        classesResponse = classesResponse.filter(
          (classItem, index, self) =>
            index === self.findIndex((t) => t.id === classItem.id)
        );

        classesResponse.sort(
          (a, b) => new Date(b.date_created) - new Date(a.date_created)
        );
        setClasses(classesResponse);

        // Get school data using the new API
        const schoolDataResponse = await getCountryId(schoolid);

        if (schoolDataResponse.countryId) {
          setCountryId(schoolDataResponse.countryId);
          setRollNumber(schoolDataResponse.rollnumber);

          const gradesResponse = await getCountryGrades(schoolDataResponse.countryId);
          setGradeLevelOptions([gradesResponse]);
        } else {
          console.warn("School data not found:", schoolDataResponse.message);
          setCountryId(null);
          setRollNumber(null);
        }

      } catch (error) {
        console.error("Error fetching school data:", error);
        setCountryId(null);
        setRollNumber(null);
      }
    }

    if (schoolid) {
      fetchSchoolData().finally(() => {
        setLoading(false);
      });
    }
  }, [schoolid]);

  // Fetch GradeLevel3 schools on mount
  useEffect(() => {
    const fetchGradeLevel3Schools = async () => {
      try {
        const activeSchools = await getActiveGradeLevel3Schools();
        setGradeLevel3Schools(activeSchools);
        console.log("Active GradeLevel3 schools:", activeSchools);
      } catch (error) {
        console.error("Error fetching GradeLevel3 schools:", error);
        setGradeLevel3Schools([]);
      }
    };

    fetchGradeLevel3Schools();
  }, []);

  useEffect(() => {
    if (name) {
      let nameArray = name.split(" ");
      setFirstname(nameArray[0]);
    }
  }, [name, schoolid]);

  useEffect(() => {
    setSpeechText(
      `Whoa slow down there ${firstname}. We need to create a class first. Click into "Classrooms" on the left to get this started`
    );
  }, [firstname]);

  useEffect(() => {
    window.HubSpotConversations?.widget?.refresh();
  }, []);

  useEffect(() => {
    const fetchTrialistDetails = async () => {
      try {
        const response = await getTrialistsBySchool(schoolid); // Fetch data
        if (response.length > 0) {
          const details = response[0]; // Assuming we use the first trial entry
          setTrialistDetails(details);

          // Calculate freeDaysLeft
          const currentDate = new Date();
          const endDate = new Date(details.end_date);
          const timeDiff = endDate - currentDate; // Difference in milliseconds
          const daysLeft = Math.ceil(timeDiff / (1000 * 60 * 60 * 24)); // Convert to days
          setFreeDaysLeft(daysLeft > 0 ? daysLeft : 0); // Ensure non-negative value
        }
      } catch (error) {
        console.error("Failed to fetch trialist details:", error);
      }
    };
    fetchTrialistDetails();
  }, [schoolid]);

  useEffect(() => {
    const fetchLatestPurchase = async () => {
      if (!schoolid) return;

      try {
        const purchaseResponse = await getPurchasesBySchool(schoolid, {
          order: "next_payment_date DESC",
          limit: 1,
        });

        setLatestPurchase(
          Array.isArray(purchaseResponse) && purchaseResponse.length > 0
            ? purchaseResponse[0]
            : null
        );
      } catch (error) {
        console.error("Error fetching purchase data:", error);
        setLatestPurchase(null);
      }
    };

    fetchLatestPurchase();
  }, [schoolid]);

  const videoContent = getVideoContent();

  useEffect(() => {
    console.log('🚀 fetchPilotAndScreeningData useEffect triggered');
    console.log('📍 Current values:', { schoolid, countryId });

    const fetchPilotAndScreeningData = async () => {
      if (!schoolid || !countryId) {
        console.log('❌ Missing required values, returning early:', { schoolid, countryId });
        return;
      }

      try {
        // Fetch pilot data
        console.log('🔍 Fetching pilot data for schoolid:', schoolid);
        const pilotResponse = await getPilotBySchoolId(schoolid);
        console.log('📊 Pilot data:', pilotResponse);
        setPilotData(pilotResponse);

        // Fetch screening window status
        console.log('🔍 Fetching screening window for countryid:', countryId);

        let screeningResponse = await getScreeningWindowStatuses({
          countryid: countryId,
          active: true
        });

        console.log('📊 Screening window data (original):', screeningResponse);

        // If no results, fallback to default
        if (!screeningResponse || screeningResponse.length === 0) {
          console.log('⚠️ Using default countryid:', DEFAULT_COUNTRY_ID);
          screeningResponse = await getScreeningWindowStatuses({
            countryid: DEFAULT_COUNTRY_ID,
            active: true
          });
          console.log('📊 Screening window data (default):', screeningResponse);
        }

        setScreeningWindowData(screeningResponse);

      } catch (error) {
        console.error('❌ Error fetching pilot/screening data:', error);
      }
    };

    fetchPilotAndScreeningData();
  }, [schoolid, countryId]);

  return (
    <div>
      <Container fluid className="vh-100">
        <HeadingBanner
          name={`${name}'s QR Code`}
          isLoggedIn={true}
          cloud={true}
          schoolid={schoolid}
          teacherid={teacherid}
          pilotData={pilotData}
          screeningWindowData={screeningWindowData}
        />

        <Row className="h-100">
          <LeftPanel />
          <Col sm={{ span: 10, offset: 2 }} className="blue-background">
            {loading ? (
              <div className="spinner-container">
                <div className="big-ball-spinner"></div>
              </div>
            ) : (
              <Row className="row-position">
                <FreeTrialBanner
                  schoolid={schoolid}
                  teacherName={name}
                  freeDaysLeft={freeDaysLeft}
                  trialistDetails={trialistDetails}
                  pilotData={pilotData}
                />
                {classes.length > 0 && (
                  <>
                    <ClassFilter
                      classes={classes}
                      setFilteredClasses={setFilteredClasses}
                      gradeLevelOptions={gradeLevelOptions}
                      teacherRoles={teacherRoles}
                      showCurrentYearOnly={true}
                      schoolid={schoolid}
                    />
                    <br></br>
                  </>
                )}
                <VideoModal
                  buttonText={videoContent.buttonText}
                  modalTitle={videoContent.modalTitle}
                  modalParagraph={videoContent.modalParagraph}
                  videos={videoContent.videos}
                />
                {classes.length === 0 ? (
                  <>
                    <Col className="col-2"></Col>
                    <Col className="alpaca-message-positioner">
                      <AlpacaInfoGesture speechText={speechText} />
                    </Col>
                  </>
                ) : (
                  filteredClasses.map((item, index) => (
                    <QRClassCard
                      key={`${item.id}-${index}`}
                      teachers={teachers}
                      teacherid={teacherid}
                      classDetails={item}
                      rollNumber={rollNumber}
                    />
                  ))
                )}
              </Row>
            )}
          </Col>
        </Row>
      </Container>
      {isPortrait && <OrientationPrompt />}
    </div>
  );
}

export default QRDashboard;
